<script>
import ElementsButton from '@/components/elements/ElementsButton.vue';
import ElementsSelectRef from '@/components/elements/ElementsSelectRef.vue';
import ElementsInput from '@/components/elements/ElementsInput.vue';
import { ValidateUtil } from '@/plugins/app-util.js';
import AppPopup from '@/components/AppPopup';
import AppPopupHeaderless from '@/components/AppPopupHeaderless';
import moment from 'moment';

export default {
    components: {
        ElementsSelectRef,
        ElementsInput,
        ElementsButton,
        AppPopup,
        AppPopupHeaderless,
    },
    props: {
        modelValue: Boolean,
    },
    emits: ['update:modelValue'],
    mounted() {
        const self = this;
        self.initAsk();
        self.getComponyData();
    },
    data() {
        return {
            showAskPopup: false,
            showSuccessPopup: false,
            typeAskOptions: [
                {
                    text: 'Top up',
                    value: 'topUp',
                },
            ],

            topupSum: 0,
            phoneNumberPrepend: '+63',

            dateOfMeeting: null,
            timeOfMeeting: { hour: null, minute: null },

            sendAskData: {
                companyName: '',
            },
            sendAskDataErrMsg: {
                askContent: '',
            },
            minuitOptions: [],
            hourOptions: [],
        };
    },
    watch: {
        modelValue(newVal) {
            const self = this;
            if (newVal) {
                self.initAsk();
                self.showAskPopup = true;
            } else {
                self.showAskPopup = false;
            }
        },
        dateOfMeeting(newDate) {
            const self = this;
            self.hourOptions = self.getFilteredHourOption(newDate);
            self.minuitOptions = self.getFilteredMinuteOption();

            const istHourValid = self.hourOptions.some(
                (opt) => opt.value === self.timeOfMeeting.hour
            );

            if (!istHourValid) {
                self.timeOfMeeting.hour = self.hourOptions[0].value;
                self.timeOfMeeting.minute = self.minuitOptions[0].value;
            }
        },
    },
    methods: {
        getFilteredHourOption(selectedDate) {
            const date = moment.utc(selectedDate).local();
            const isToday = date.isSame(moment(), 'day');
            const startHour = isToday ? moment().hour() + 1 : 0;

            let hourOptions = Array.from({ length: 24 - startHour }, (_, i) => {
                const hour = (startHour + i).toString().padStart(2, '0');
                return { text: hour, value: hour };
            });

            // 만약 선택 가능한 시간이 없을 경우 (당일 23시 이후에 선택하고자함)-> 00 만 선택가능
            if (hourOptions?.length == 0) {
                return [{ text: '00', value: '00' }];
            }

            return hourOptions;
        },
        getFilteredMinuteOption() {
            return Array.from({ length: 6 }, (_, i) => i * 10).map((min) => {
                const minOption = min.toString().padEnd(2, '0');
                return { text: minOption, value: minOption };
            });
        },
        onInputMileage(event) {
            const self = this;

            const input = event.target.value;
            let mileage = input.replace(/[^0-9]/g, '');

            self.sendAskData.topUpAmount = mileage;
        },
        hidePopup() {
            const self = this;
            // self.showAskPopup = false;
            self.$emit('update:modelValue', false);
        },
        hideSuccessPopup() {
            const self = this;
            self.showSuccessPopup = false;
        },
        getComponyData() {
            const self = this;
            const url = self.$api('uri', 'get-company');
            self.$axios
                .get(url, {})
                .then(function (res) {
                    const companyData = res.data.data;
                    self.sendAskData.companyName = companyData.companyName;
                })
                .catch((error) => {
                    console.error('when getData error => ', error);
                });
        },
        initAsk() {
            const self = this;

            //init
            self.dateOfMeeting = new Date();
            self.sendAskData = {
                ...self.sendAskData,
                userName: '',
                phoneNumber: '',
                email: '',
                topUpAmount: '',
                inquiryContent: '',
            };
            self.sendAskDataErrMsg = { ...self.sendAskData };
        },
        checkValidation() {
            const self = this;
            let validationCnt = 0;

            //init
            self.sendAskDataErrMsg = {
                userName: '',
                phoneNumber: '',
                email: '',
                topUpAmount: '',
                inquiryContent: '',
            };

            if (ValidateUtil.checkIsEmpty(self.sendAskData.userName)) {
                self.sendAskDataErrMsg.userName = "Name can't be blank.";
                validationCnt++;
            }
            if (!ValidateUtil.checkPhone(self.sendAskData.phoneNumber)) {
                self.sendAskDataErrMsg.phoneNumber = 'Please enter a valid phone number.';
                validationCnt++;
            }
            if (!ValidateUtil.checkIsEmail(self.sendAskData.email)) {
                self.sendAskDataErrMsg.email = 'Please enter a valid email address.';
                validationCnt++;
            }
            if (!ValidateUtil.checkIsNumber(self.sendAskData.topUpAmount)) {
                self.sendAskDataErrMsg.topUpAmount = 'Please enter a valid top up amount.';
                validationCnt++;
            }
            if (ValidateUtil.checkIsEmpty(self.sendAskData.inquiryContent)) {
                self.sendAskDataErrMsg.inquiryContent = "Inquiry content can't be blank.";
                validationCnt++;
            }

            return validationCnt;
        },
        sendAsk() {
            const self = this;

            //validation 통과 했을때
            if (self.checkValidation() == 0) {
                const url = self.$api('uri', 'post-topup-ask-email');
                const { hour, minute } = self.timeOfMeeting;
                self.sendAskData.timeOfMeeting = `${hour}:${minute}`;
                self.sendAskData.dateOfMeeting = moment(self.dateOfMeeting)
                    .local()
                    .format('MM/DD/YYYY');
                self.$axios
                    .post(url, self.sendAskData)
                    .then((res) => {
                        self.showSuccessPopup = true;
                        self.hidePopup();
                    })
                    .catch((err) => {
                        console.error('err ? : ', err);
                    });
            }
        },
    },
};
</script>

<template>
    <AppPopup v-model="showAskPopup" name="Contact to HRnFLEX" @afterClose="hidePopup">
        <div class="pr-7 pb-7 pl-2.5 w-[644px]">
            <div class="flex items-center gap-4 mt-6">
                <div class="w-[15%] text-right text-sm font-semibold text-slate-800"> Company </div>
                <ElementsInput
                    v-model="sendAskData.companyName"
                    :readonly="true"
                    class="flex-1"
                    :full="true" />
            </div>
            <div class="flex items-center gap-4 mt-6">
                <div class="w-[15%] text-right text-[14px] font-semibold text-slate-800">
                    Name
                </div>
                <ElementsInput
                    v-model.trim="sendAskData.userName"
                    placeholder="Enter Full Name"
                    class="flex-1"
                    :error="sendAskDataErrMsg.userName"
                    :full="true" />
            </div>
            <div class="flex items-center gap-4 mt-6">
                <div class="w-[15%] text-right text-[14px] font-semibold text-slate-800">
                    Mobile number
                </div>
                <div class="flex-1 flex flex-col">
                    <div class="flex-1 flex items-center gap-3.5">
                        <ElementsInput
                            v-model="phoneNumberPrepend"
                            :width14="true"
                            :disabled="true" />
                        <ElementsInput
                            v-model.trim="sendAskData.phoneNumber"
                            placeholder="Enter Phone Number"
                            class="flex-1"
                            :error="sendAskDataErrMsg.phoneNumber"
                            :showErrorMessage="false"
                            :full="true" />
                    </div>
                    <div
                        class="mt-1.5 text-xs font-normal text-[#FF0000]"
                        v-show="sendAskDataErrMsg.phoneNumber">
                        *{{ sendAskDataErrMsg.phoneNumber }}
                    </div>
                </div>
            </div>
            <div class="flex items-center gap-4 mt-6">
                <div class="w-[15%] text-right text-[14px] font-semibold text-slate-800">
                    Email
                </div>
                <div class="flex-1 flex justify-between items-center gap-3.5">
                    <ElementsInput
                        v-model.trim="sendAskData.email"
                        placeholder="Enter Email"
                        class="flex-1"
                        :error="sendAskDataErrMsg.email"
                        :full="true" />
                </div>
            </div>
            <div class="flex items-center gap-4 mt-6">
                <div class="w-[15%] text-right text-[14px] font-semibold text-slate-800">
                    Date of Meeting
                </div>
                <div class="flex-1 flex justify-between items-center gap-3.5">
                    <Datepicker
                        v-model="dateOfMeeting"
                        :inputFormat="'MM/dd/yyyy'"
                        :placeholder="'MM/dd/yyyy'"
                        class="w-[150px] h-[40px] border border-gray-300 rounded-lg shadow-sm cursor-pointer"
                        :lowerLimit="new Date()"
                        :typeable="false"
                        :startingView="'day'"
                        :minimumView="'day'"
                        :weekStartsOn="0"
                        :dayPickerHeadingFormat="'MM/dd/yyyy'"
                        :required="false" />
                </div>
            </div>
            <div class="flex items-center gap-4 mt-6">
                <div class="w-[15%] text-right text-[14px] font-semibold text-slate-800">
                    Time of Meeting
                </div>
                <div class="w-[85%] flex items-center gap-2">
                    <ElementsSelectRef
                        :width24="true"
                        :placeholder="'HH'"
                        :options="hourOptions"
                        v-model="timeOfMeeting.hour" />
                    <ElementsSelectRef
                        :width24="true"
                        :placeholder="'mm'"
                        v-model="timeOfMeeting.minute"
                        :options="minuitOptions" />
                </div>
            </div>
            <div class="flex items-center gap-4 mt-6">
                <div class="w-[15%] text-right text-[14px] font-semibold text-slate-800">
                    Top up Amount
                </div>
                <div class="flex-1 flex justify-between items-center gap-3.5">
                    <ElementsInput
                        v-model.trim="sendAskData.topUpAmount"
                        placeholder="Enter Top up Amount"
                        class="flex-1"
                        :error="sendAskDataErrMsg.topUpAmount"
                        :full="true"
                        @input="onInputMileage($event)" />
                </div>
            </div>
            <div class="flex items-center gap-4 mt-6">
                <div class="w-[15%] text-right text-[14px] font-semibold text-slate-800">
                    Remarks
                </div>
                <div class="flex flex-col w-full h-full">
                    <div class="flex-1 flex items-center">
                        <textarea
                            v-model.trim="sendAskData.inquiryContent"
                            class="resize-none outline-0 w-full h-[161px] text-sm border rounded-lg py-1 px-3 bg-white shadow shadow-gray-100"
                            :class="{ 'border-red-500': sendAskDataErrMsg.inquiryContent }" />
                    </div>
                    <div
                        class="flex mt-1.5 text-xs font-normal text-[#FF0000]"
                        v-show="sendAskDataErrMsg.inquiryContent">
                        *{{ sendAskDataErrMsg.inquiryContent }}
                    </div>
                </div>
            </div>
        </div>
        <div class="sticky bottom-0">
            <div class="w-full h-px bg-gray-200"></div>
            <div class="px-4 py-6 flex justify-end w-full bg-white">
                <ElementsButton class="w-full" text="Contact" :widthFull="true" @click="sendAsk" />
            </div>
        </div>
    </AppPopup>
    <AppPopupHeaderless
        v-model="showSuccessPopup"
        :hideTitle="true"
        min-width="32.75em"
        width="32.75em"
        height="13.5em">
        <div class="flex flex-col justify-center items-center space-y-4 p-5">
            <div class="p-6 space-y-6 text-center text-[20px] text-[#504F54]">
                Your top up request has been successfully completed!
            </div>
            <button
                @click="hideSuccessPopup"
                type="button"
                class="h-[3.125rem] w-[10rem] border-[1px] border-[#D6DDEB] rounded-lg text-sm font-semibold text-white text-center bg-[#4261EE] hover:bg-[#D6DDEB]">
                OK
            </button>
        </div>
    </AppPopupHeaderless>
</template>
<style scoped>
.box-style-border {
    border: 1px solid #d1d5db;
}
</style>
